/**
 * @property BANK_TRANSFER 직접계좌이체
 * @property BANK_CARD 체크/신용카드
 * @property TOKEN_BILLING_KEY
 * @property PHONE 휴대폰
 * @property NICEPAY_PAYCO_HUB 페이코 (x)
 * @property PAYCO 페이코
 * @property NICEPAY_KAKAOPAY_HUB 카카오페이 (x)
 * @property KAKAOPAY 카카오페이
 * @property NPAY 네이버페이
 * @property TOSSPAY 토스페이
 * @property SAMSUNGPAY 삼성페이
 * @property LPAY 엘페이
 * @property SSG SSG페이
 * @property APPLEPAY 애플페이
 * @property VBANK 가상계좌이체
 * @property TODAYFRUIT_PAY_CARD 오늘과일페이(카드)
 * @property TODAYFRUIT_PAY_BANK_TRANSFER 오늘과일페이(계좌이체)
 * @property QUICK_TRANSFER 퀵계좌이체
 */
export enum PaymentMethodType {
    BANK_TRANSFER = 'bank_transfer',
    BANK_CARD = 'bank_card',
    TOKEN_BILLING_KEY = 'token_billing_key',
    PHONE = 'phone',
    NICEPAY_PAYCO_HUB = 'nicepay_payco_hub',
    PAYCO = 'payco',
    NICEPAY_KAKAOPAY_HUB = 'nicepay_kakaopay_hub',
    KAKAOPAY = 'kakaopay',
    NPAY = 'npay',
    TOSSPAY = 'tosspay',
    SAMSUNGPAY = 'samsungpay',
    LPAY = 'lpay',
    SSG = 'ssg',
    APPLEPAY = 'applepay',
    VBANK = 'vbank',

    TODAYFRUIT_PAY_CARD = 'todayfruit_pay_card',
    TODAYFRUIT_PAY_BANK_TRANSFER = 'todayfruit_pay_bank_transfer',
    QUICK_TRANSFER = 'quick_transfer',

    UNKNOWN = 'unknown',
}
